/***********************************************
* UploadZone.js
* 
* Upload a DXF zone to the server
***********************************************/
/* Layout files */
//import '../assets/style/OutputList.css';

/* Global imports */
import React from 'react';

/* Local imports */
import API from '../API';

export default function UploadZone(props) {
    const inputId = `zonefile-${Math.random().toString(36).substring(2, 11)}`;

    const handleFileChange = (event) => {
        if(!event.target.files[0]){ return; }

        API.UploadZone(props.id, event.target.files[0], null, (id) => {props.onZoneId(id);});
    }

    return (<>
        <label htmlFor={inputId} className='button zonebutton'>{props.t("upload")}</label>
        <input id={inputId} type="file" onChange={handleFileChange} accept=".dxf,.DXF" style={{display: "none"}} />
    </>);
}